import React from "react"
import createStyles from "@mui/styles/createStyles"
import makeStyles from "@mui/styles/makeStyles"
import Typography from "@mui/material/Typography"
import moment from "moment"

import { COLORS } from "../../utils"

const useStyles = makeStyles(() =>
    createStyles({
        title: {
            display: "flex",
            color: COLORS.BLACK_CARD,
            fontWeight: "bold",
            fontSize: 32,
        },
        subTitle: {
            marginLeft: 22,
            fontWeight: 500,
            fontSize: 16
        },
        typeAndDlc: {
            fontWeight: "normal",
            fontSize: 12,
            "& span": {
                paddingRight: 14,
                textTransform: "uppercase"
            }
        }
    }),
)

/**
 * KFC-353: `productTypes` is the full referential, `productTypeOptions` the list filtered on
 * managementMode for the "add a product" modal — which drops every "manual" category, so
 * Plat, Entrée, Dessert and Boisson never resolved and the type stayed blank on most cards.
 *
 * Callers that hold the whole referential pass it and get a label every time; the others keep
 * the previous behaviour.
 */
const findProductTypeLabel = (productType, productTypes, productTypeOptions) => {
    const fromReferential = (productTypes || []).find(candidate => candidate.kfcName === productType)
    if (fromReferential) return fromReferential.label

    return (productTypeOptions || []).find(option => option.type === productType)?.label
}

const ActionHeaderText = (props) => {
    const { selectedCard, productTypeOptions, productTypes } = props
    const classes = useStyles()
    const dlc = moment(selectedCard.dlc).isSame(new Date(), "year") ? moment.utc(selectedCard.dlc).format("DD/MM") : moment.utc(selectedCard.dlc).format("DD/MM/YY")
    const productType = findProductTypeLabel(selectedCard.productType, productTypes, productTypeOptions)

    return (
        <>
            <Typography className={classes.title}>
                { selectedCard.uniqueCode }
            </Typography>
            <div className={classes.subTitle}>
                <div>{selectedCard.commercialTitle}</div>
                <div className={classes.typeAndDlc}>
                    <span>{productType}</span>DLC: {dlc}
                </div>
            </div>
        </>
    )
}

export default ActionHeaderText